/* eslint-disable max-len,no-irregular-whitespace */
import React from 'react';
import { Link } from 'gatsby';
import Layout from '../../components/Layout';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import SEO from '../../components/seo';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import './style.scss';

const PrivacyPolicyPage = () => (
    <Layout id="privacy-policy-page">
        <SEO title="Privacy Policy" />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content container content">
            <div className="is-size-2-touch is-size-3-desktop is-spaced content has-text-centered-touch">Privacy Policy</div>
            <br />
            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Cookies and how they benefit you</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
                Our website uses cookies, as almost all websites do, to help provide you with the
                best experience we can. Cookies are small text files that are placed on your
                computer or mobile phone when you browse websites
                <br />
                <br />
                <strong>Our cookies help us:</strong>
                <ul>
                    <li>Make our website work as you’d expect</li>
                    <li>Save you having to login every time you visit the site</li>
                    <li>Remember your settings during and between visits</li>
                    <li>Improve the speed/security of the site</li>
                    <li>Allow you to share pages with social networks like Facebook</li>
                    <li>Personalise our site to you to help you get what you need faster</li>
                    <li>Continuously improve our website for you</li>
                    <li>
                        Make our marketing more efficient (ultimately helping us to offer the service
                        we do at the price we do)
                    </li>
                </ul>
                <strong>We do not use cookies to:</strong>
                <ul>
                    <li>
                    Collect any personally identifiable information (without your express
                    permission)
                    </li>
                    <li>Collect any sensitive information (without your express permission)</li>
                    <li>Pass personally identifiable data to third parties</li>
                </ul>
                <br />
            You can learn more about all the cookies we use below
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">
            Granting us permission to use cookies
            </div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            If the settings on your software that you are using to view this website (your browser) are adjusted to
            accept cookies we take this, and your continued use of our website, to mean that you are fine with this.
            Should you wish to remove or not use cookies from our site you can learn how to do this below, however
            doing so will likely mean that our site will not work as you would expect. This cookie policy was last
            updated on 13th September 2016.
            </div>
            <div className="title is-size-5-touch is-size-4-desktop is-spaced">More About Our Cookies</div>
            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Website Function Cookies</div>

            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            We use cookies to make our website work including:
                <ul>
                    <li>Making our shopping basket and checkout work</li>
                    <li>Determining if you are logged in or not</li>
                    <li>Remembering your search settings</li>
                    <li>Allowing you to add comments to our site</li>
                    <li>Tailoring content to your needs</li>
                    <li>
                    Remembering if we have already asked you certain questions (e.g. you declined to use our app or
                    take our survey)
                    </li>
                </ul>
                <br />

            There is no way to prevent these cookies being set other than to not use our site.
            </div>
            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Third Party Functions</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            Our site, like most websites, includes functionality provided by third parties. A common example is an
            embedded YouTube video. Disabling these cookies will likely break the functions offered by these third
            parties
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Social Website Cookies</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            So you can easily “Like” or share our content on the likes of Facebook and Twitter we have included
            sharing buttons on our site.
                <br />
                <br />
            Cookies are set by:
                <ul>
                    <li>
Facebook –
                        <Link
                            className="button is-link"
                            to="/privacy-policy"
                            style={{ marginLeft: '10px' }}
                        >
Privacy Policy
                        </Link>
                    </li>
                </ul>
                <br />
            The privacy implications on this will vary from social network to social network and will be dependent
            on the privacy settings you have chosen on these networks.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Advertising Cookies</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            Cookies are widely used in online advertising. Neither us, advertisers or our advertising partners can
            gain personally identifiable information from these cookies.
            You can learn more about online advertising at http://www.youronlinechoices.com . You can opt-out of
            almost all advertising cookies at http://www.youronlinechoices.com/uk/your-ad-choices although we would
            prefer that you didn’t as ultimately adverts help keep much of the internet free. It is also worth
            noting that opting out of advertising cookies will not mean you won’t see adverts, just simply that they
            won’t be tailored to you any longer.
                <br />
                <br />
            We use:
                <ul>
                    <li>
DoubleClick –
                        <a
                            className="button is-link"
                            href="http://cookie.attacat.co.uk/policy_plain.php"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ margin: '0 10px' }}
                        >
                        Privacy Policy
                        </a>
owned by Google
                    </li>
                </ul>
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Remarketing Cookies</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            You may notice that sometimes after visiting a site you see increased numbers of adverts from the site
            you visited. This is because advertisers, including ourselves pay for these adverts. The technology to
            do this is made possible by cookies and as such we may place a so called “remarketing cookie” during
            your visit. We use these adverts to offer special offers etc to encourage you to come back to our site.
            Don’t worry we are unable to proactively reach out to you as the whole process is entirely anonymised.
            You can opt out of these cookies at anytime as explained above.
            </div>


            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Turning Cookies Off</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            You can usually switch cookies off by adjusting your browser settings to stop it from accepting cookies
            (Learn how
                <a
                    className="button is-link"
                    href="http://www.attacat.co.uk/resources/cookies/how-to-ban"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: '10px' }}
                >
                here
                </a>
            ). Doing so however will likely limit the functionality of our’s and a large proportion of the world’s
            websites as cookies are a standard part of most modern websites
                <br />
                <br />
            It may be that your concerns around cookies relate to so called “spyware”. Rather than switching off
            cookies in your browser you may find that anti-spyware software achieves the same objective by
            automatically deleting cookies considered to be invasive. Learn more about
                <a
                    className="button is-link"
                    href="http://www.attacat.co.uk/resources/cookies/how-to-control-your-online-privacy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: '10px' }}
                >
                    managing cookies with antispyware software.
                </a>
            </div>


            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Privacy Policy and Data Protection</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            This is the privacy policy for http://www.drwatson.co.uk and each of our mobile applications that we
            make available from time to time (Application(s)). The Site is operated and the Applications are
            provided by BREATHE INTERNATIONAL LTD (we, us and our). For the purposes of the Data Protection Act
            1998, we are the data controller.
                <br />
                <br />
            We are committed to protecting your privacy online. We appreciate that you do not want the personal
            information you provide to us distributed indiscriminately and here we explain how we collect
            information, what we do with it and what controls you have. By using the Site or any Application, you
            consent to the collection and use of information in accordance with this privacy policy.
                <br />
                <br />
            We reserve the right to change this privacy policy from time to time by changing it on the Site or
            updating the relevant Application.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Information we may collect from you</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            We may collect and process the following personal information about you:
                <br />
                <br />

                <ul>
                    <li>
                    information (such as your name, email and postal address, telephone number, height, age, sex,
                    dietary needs, exercise programs, and PAR Q forms that you provide by completing forms on the
                    Site or Application, including if you register as a user of the Site or Application, subscribe
                    to our newsletter, upload or submit any material via the Site or Application, or request any
                    information;
                    </li>
                    <li>in connection with an account sign-in facility, your log-in and password details;</li>
                    <li>details of any transactions made by you through the Site or Application;</li>
                    <li>
                    communications you send to us, for example to report a problem or to submit queries, concerns or
                    comments regarding the Site or Application;
                    </li>
                    <li>
                    information from surveys, promotions and competitions that we may, from time to time, run on the
                    Site or Application, if you choose to respond to, or participate in, them;
                    </li>
                    <li>technical information from your mobile device relating to the service you receive;</li>
                    <li>information relating to your real time location; and</li>
                    <li>information that you post in the form of comments or contributions to discussions.</li>
                </ul>
                <br />
                <br />
            You are under no obligation to provide any such information. However, if you should choose to withhold
            requested information, we may not be able to provide you with certain services.
                <br />
                <br />
            We may, from time to time, run referral programmes or similar initiatives, such as a “Refer a Client”
            programme, that invite you to provide us with the contact details of someone who is known to you who may
            find our products or services to be of interest. We will only use those contact details for the purpose
            of the relevant initiative (and not for general marketing purposes). Any referral information that you
            provide will not be made available to other users of the Site or Application. By providing us with their
            details, you confirm that you have their permission to do so and you must not provide us with the
            details of anyone from whom you do not have such permission. We reserve the right to identify you as the
            person who made the referral in the message that is sent to them.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Uses made of your information</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            We will use the personal information you provide to:
                <br />
                <ul>
                    <li>identify you when you sign-in to your account;</li>
                    <li>
                    enable us to administer your account, process your orders and to provide you with the services
                    and information offered through the Site and which you request;
                    </li>
                    <li>
                    verify and carry out financial transactions in relation to payments and subscriptions you make
                    through the Site or the Application;
                    </li>
                    <li>
                    analyse the use of the Application the Site and, in relation to the Site, the people visiting in
                    order to improve our content and services including research into our users’ demographics and
                    tracking of sales data;
                    </li>
                    <li>
                    collect your real time location to provide location services requested by you in order to allow
                    tagging and to check-in clients, personal trainers or others. This feature will only be made
                    available to you if you chose to opt-in to use it. This information may be shared with third
                    parties for their separate use but you may opt out at any time from allowing further access by
                    us to your location data in the options menu of the Application or the settings menu of your
                    mobile device. You can also stop all information collection by uninstalling an Application. You
                    may use the standard uninstall processes as may be available as part of you mobile device or via
                    the Application market place network.
                    </li>
                    <li>
                    send you information we think you may find useful or which you have requested from us, including
                    receipt of marketing communications such as our periodic newsletter provided you have indicated
                    that you are happy to be contacted for these purposes; and
                    </li>
                    <li>
                    allow, with your consent, carefully selected third parties to send you information directly
                    which you may find useful regarding their products and services.
                    </li>
                </ul>
                <br />
            You can tell us not to contact you with information regarding our products and services or those of
            third parties, or to share your details with third parties so that they can send you information
            regarding their products and services, either at the point such information is collected on the Site or
            Application (by checking or un-checking (as directed) the relevant box) or, where you do not wish us to
            continue to use your information in this way, by following the unsubscribe instructions on any
            communications sent to you. You can also exercise this right at any time by contacting us using the
            contacting us details at the end of this privacy policy.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Additional information</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            When you visit the Site or access or use any Application, we may automatically collect additional
            information about you, such as the type of internet browser or mobile device you use, any website from
            which you have come to the Site or Application and your IP address (the unique address which identifies
            your device on the internet) and your operating system, which are automatically recognised by our web
            server. You cannot be identified from this information and it is only used to assist us in providing an
            effective service on the Site or Application and to collect broad demographic information for aggregate
            use.
                <br />
                <br />
            In addition to cookies we may use the following similar technologies in respect of your use of the Site
            or Applications:
                <br />
                <br />
                <ul>
                    <li>
                    Web beacons – these are small image files that may be placed by us or third parties in respect
                    of your use of the Site or within the body of our newsletters so we or third parties can
                    understand which parts of the Site are visited or whether particular content is of interest.
                    </li>
                    <li>Application specific tracking</li>
                </ul>
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Information sharing</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            We may disclose aggregate statistics about visitors to the Site and users of the Application (customers
            and sales) in order to describe our services to prospective partners, advertisers, sponsors and other
            reputable third parties and for other lawful purposes, but these statistics will include no personally
            identifiable information.
                <br />
                <br />
            We may disclose your personal information to any of our affiliates, or to our agents or contractors who
            assist us in providing the services we offer through the Site or the Application, processing
            transactions, fulfilling requests for information, receiving and sending communications, updating
            marketing lists, analysing data, providing support services or in other tasks from time to time. Our
            agents and contractors will only use your information to the extent necessary to perform their
            functions.
                <br />
                <br />
            In the event that we undergo re-organisation or are sold to a third party, you agree that any personal
            information we hold about you may be transferred to that re-organised entity or third party.
                <br />
                <br />
            We may disclose your personal information if legally entitled or required to do so (for example if
            required by law or by a Court order or if we believe that such action is necessary to prevent fraud or
            cyber crime or to protect the Site or Applications or the rights, property or personal safety of any
            person).
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Public forums</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            The Site and Applications may, from time to time, make chat rooms, message boards, news groups and/or
            other public forums available to its users. Any information that is disclosed in these areas becomes
            public information and you should exercise caution when using these and never disclose your personal
            information.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Child safety</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            Persons under the age of 18 are not legally allowed access to this website. We recommend parental
            controls for our or any such sights with similar content
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">External links</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            The Site and Applications may, from time to time, contain links to external sites. We are not
            responsible for the privacy policies or the content of such sites.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Payment processing</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            Payment details you provide will be encrypted using secure sockets layer (SSL) technology before they
            are submitted to us over the internet. Payments made on the Site or Application are made through our
            payment solution provider Worldpay. You will be providing credit or debit card information directly to
            their providers who operate a secure server to process payment details, encrypting your credit/debit
            card information and authorising payment. Information which you supply to Worldpay is not within our
            control and is subject to their own privacy policies, terms and conditions.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Security</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>

            We place great importance on the security of all personally identifiable information associated with our
            users. We have security measures in place to attempt to protect against the loss, misuse and alteration
            of personal information under our control. For example, our security and privacy policies are
            periodically reviewed and enhanced as necessary and only authorised personnel have access to personal
            information. Whilst we cannot ensure or guarantee that loss, misuse or alteration of information will
            never occur, we use all reasonable efforts to prevent it.
                <br />
                <br />
            You should bear in mind that submission of information over the internet is never entirely secure. We
            cannot guarantee the security of information you submit via the Site or Application whilst it is in
            transit over the internet and any such submission is at your own risk.
                <br />
                <br />
            It is advisable to close your browser or the Application when you have finished your user session to
            help ensure others do not access your personal information.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">
            Data storage and international
            transfers
            </div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            Information that you submit via the Site or Application is sent to and stored on secure servers located
            in the United Kingdom. By submitting information via the Site or Application, you agree to this storing,
            processing and/or transfer.
            In addition, if you use our services while you are outside the UK, your information may be transferred
            outside the UK in order to provide you with those services.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Your rights</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            You have a legal right under the Data Protection Act 1998 to a copy of all the personal information
            about you held by us. On request, we will provide you with a copy of this information subject to a fee
            not exceeding the prescribed fee permitted by law. You also have a right to correct any errors in that
            information. As mentioned above, you have a right to prevent the use of your personal information for
            direct marketing purposes.
            </div>

            <div className="title is-size-5-touch is-size-4-desktop is-spaced">Contacting us</div>
            <div className="subtitle is-size-5-touch is-size-4-desktop" style={{ marginBottom: '4rem' }}>
            Please submit any questions, concerns or comments you have about this privacy policy or any requests
            concerning your personal data by email to
                <a
                    className="button is-link"
                    href="mailto:hello@drwatson.co.uk"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: '10px' }}
                >
                hello@drwatson.co.uk
                </a>
            </div>
        </div>
        <Footer />

    </Layout>
);
export default PrivacyPolicyPage;
